import React, { useEffect } from "react";

const VideoLightbox = ({ isOpen, videoId, title = "", onClose }) => {
  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-3 bg-black/70">
      <button
        aria-label="Close video"
        onClick={onClose}
        className="absolute top-4 right-4 rounded-full bg-white/90 hover:bg-white text-gray-700 shadow p-2"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>

      <div className="w-full max-w-4xl bg-black rounded-xl overflow-hidden shadow-2xl">
        <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
          <iframe
            title={title || "Tutorial video"}
            className="absolute inset-0 w-full h-full"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
        {title ? (
          <div className="px-4 py-3 bg-black text-white text-sm border-t border-white/10">
            {title}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default VideoLightbox;
